import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_OFFERS, SET_TAB } from 'dealer-reducers'
import { RootReducer } from '../../redux/rootReducer'
import Layout from '../layout/Layout'
import { useTranslation } from 'react-i18next'
import FlatList from '../molecules/FlatList'
import LikeItem from '../molecules/LikeItem'
import { ListOffer } from 'dealer-types'
import LaptopSvg from '../other/svg/LaptopSvg'
import OfferModal from './OfferModal'
import OfferFilters from '../molecules/OfferFilters'
import PaginatedOffers from './PaginatedOffers'
const DealerOffers = (): JSX.Element => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const containerRef = useRef<HTMLDivElement>(null)
  const { offers } = useSelector((state: RootReducer) => state.offersListReducer.dealer_offers)
  const { paginationType } = useSelector((state: RootReducer) => state.layoutReducer)
  const tab = useSelector((state: RootReducer) => state.offersListReducer.tab)

  useEffect(() => {
    dispatch(SET_TAB({ tab: 'dealer_offers' }))
    dispatch(FETCH_OFFERS({ tab: 'dealer_offers' }))
  }, [dispatch])

  return (
    <div>
      <Layout
        iconComponent={<LaptopSvg className="w-8 h-8 text-white" />}
        withFiler={true}
        name={t('bets_table_title')}>
        <div className="h-[calc(100vh-200px)]">
          <OfferFilters containerRef={containerRef} />

          {paginationType === 'infinite' && (
            <FlatList
              data={offers}
              component={(itemProps: ListOffer) => <LikeItem {...itemProps} />}
              // eslint-disable-next-line require-await
              fetchMore={async () => {
                dispatch(FETCH_OFFERS({ tab: 'dealer_offers' }))
                // eslint-disable-next-line @typescript-eslint/return-await
                return Promise.resolve()
              }}
              itemMinWidth={'100%'}
            />
          )}
          {paginationType === 'paginated' && tab === 'dealer_offers' && <PaginatedOffers component={LikeItem} />}
        </div>
      </Layout>
      <OfferModal />
    </div>
  )
}

export default DealerOffers
